import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask2900To2999Service {

  constructor() { }
}
